export enum SubscriptionPlan {
  Monthly = "Monthly",
  Annual = "Annual",
}
